<template>
  <div>
    <button
      v-if="node.children"
      :href="node.url"
      :class="{ 'is-active': isActive }"
      :aria-expanded="childrenVisible"
      @click.prevent="toggleChildrenVisibility"
    >
      <slot></slot>
      <span>{{node.title}}</span>
      <svg class="toggleIcon" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 6">
        <path d="M5.304 5.529L10 .557M1 .557L5.696 5.53" stroke="#F27A6D"/>
      </svg>
    </button>
    <a
      v-else
      :href="node.url"
      :class="{ 'is-active': isActive }"
    >{{node.title}}
    </a>
      <transition-expand>
        <ul v-show="childrenVisible" class="subnav" :aria-hidden="!childrenVisible" :test-data="JSON.stringify(node.children)">
          <li v-for="(child, index) in node.children" :key="index" class="navbar-item">
            <a :href="child.url">
              {{child.title}}
            </a>
          </li>
        </ul>
      </transition-expand>
  </div>
</template>

<script>
import TransitionExpand from '@components/TransitionExpand.vue'
import { eventBus } from '@global/eventBus'
export default {
  components: {
    TransitionExpand
  },
  props: {
    node: {
      type: Object,
      default: () => {}
    }
  },
  data: () => {
    return {
      childrenVisible: false
    }
  },
  methods: {
    toggleChildrenVisibility () {
      eventBus.$emit('toggleNav', this.unique)
      this.childrenVisible = !this.childrenVisible
    },
    hideChildren (unique) {
      if (unique !== this.unique) {
        this.childrenVisible = false
      }
    }
  },
  computed: {
    isActive () {
      return this.node.active
    },
    unique () {
      return this.node.url
    }
  },
  mounted () {
    eventBus.$on('toggleNav', this.hideChildren)
  }
}
</script>

<style scoped lang="scss">
  .navbar-item {
    position: relative;
  }
  .subnav {
    position: absolute;
  }
  .toggleIcon {
    transition: transform 0.2s ease-in-out;
  }
  [aria-expanded="true"] .toggleIcon {
    transform: rotate(180deg);
  }
</style>
